import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b5b94312&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b5b94312&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=b5b94312&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b94312",
  null
  
)

export default component.exports